import moment from 'moment';

/**
 * Compact GMT offset label from minutes east of UTC:
 *   480 -> "GMT+8"   390 -> "GMT+6:30"   0 -> "GMT+0"   -300 -> "GMT-5"
 */
export function gmtOffsetLabel(offsetMinutes: number): string {
	const sign = offsetMinutes < 0 ? '-' : '+';
	const abs = Math.abs(offsetMinutes);
	const hours = Math.floor(abs / 60);
	const minutes = abs % 60;
	return `GMT${sign}${hours}${minutes ? ':' + String(minutes).padStart(2, '0') : ''}`;
}

/**
 * Format an epoch-millis timestamp (or Date) in the viewer's LOCAL browser
 * timezone with an explicit, accurate offset label, e.g.:
 *   "25 Jun 2026 09:57 AM (GMT+6:30)"
 *
 * The time and the label are both derived from the same moment, so the label
 * always matches the displayed time regardless of the viewer's timezone.
 */
export function formatDateTimeWithZone(value: number | Date): string {
	const m = moment(value);
	return `${m.format('DD MMM YYYY hh:mm A')} (${gmtOffsetLabel(m.utcOffset())})`;
}
